var map = {
	"./0-1.png": "262f",
	"./0-2.png": "f287",
	"./0-3.png": "4370",
	"./0-4.png": "ab2f",
	"./0-5.png": "a191",
	"./1.png": "8372",
	"./10.png": "a112",
	"./11.png": "2377",
	"./12.png": "99de",
	"./13.png": "5396",
	"./14.png": "a122",
	"./15.png": "536e",
	"./16.png": "9683",
	"./17.png": "d47e",
	"./18.png": "bad8",
	"./19.png": "1caa",
	"./2.png": "be53",
	"./20.png": "6d30",
	"./21.png": "8bfe",
	"./22.png": "42c0",
	"./23.png": "f923",
	"./24.png": "589a",
	"./3.png": "46b3",
	"./36kr.png": "7eeb",
	"./4.png": "2094",
	"./5.png": "45c6",
	"./6.png": "9109",
	"./7.png": "d7fa",
	"./8.png": "1923",
	"./9.png": "9039",
	"./BG2-text.png": "2028",
	"./CCCS.png": "fa3d",
	"./acasia.png": "3d9b",
	"./aifenxi.png": "8b74",
	"./avaya.png": "1bb4",
	"./baoli.png": "4d8b",
	"./baoma.png": "2b89",
	"./baosteel.png": "37e2",
	"./beijin.png": "9152",
	"./bilibili.png": "ecf0",
	"./bmw.png": "74ba",
	"./bohai.png": "c94f",
	"./bonvoy.png": "c635",
	"./bosch.png": "cbf9",
	"./budweisek.png": "b1ba",
	"./changhong.png": "2c6a",
	"./danone.png": "215a",
	"./dazhong.png": "00c0",
	"./fushikang.png": "79a7",
	"./gartner.png": "7386",
	"./gongxingbu.png": "64cb",
	"./guangda.png": "1c55",
	"./gucci.png": "bcdd",
	"./hainanhedian.png": "316a",
	"./hanhui.png": "823f",
	"./haomai.png": "d288",
	"./heima.png": "c2d3",
	"./hengda.png": "c044",
	"./huarun.png": "bc71",
	"./huatai.png": "034e",
	"./huatairenshou.png": "1381",
	"./huawei.png": "2c9f",
	"./huawei_icon_active.png": "4656",
	"./huaxia.png": "83b3",
	"./huaxia_icon.png": "5925",
	"./huaxia_icon_active.png": "6306",
	"./ickey_img.png": "65ca",
	"./ickey_logo.png": "a439",
	"./intel.png": "e503",
	"./jiangxi.png": "a1ef",
	"./jianshe.png": "f4c3",
	"./jiaotong.png": "9586",
	"./jinyingjiang.png": "a761",
	"./jiqizhixin.png": "2d04",
	"./jiufu.png": "90db",
	"./kewosi.png": "e9d0",
	"./leifeng.png": "2119",
	"./lieyunwang.png": "3bde",
	"./loreal.png": "f492",
	"./lv.png": "a4f8",
	"./meikailong.png": "04d0",
	"./migu.png": "054b",
	"./mingsheng.png": "45d9",
	"./mingsheng_icon.png": "7b0d",
	"./mingsheng_icon_active.png": "6df1",
	"./obasf.png": "4fdc",
	"./peacebird.png": "e55e",
	"./pharmeyes_img.png": "e947",
	"./pharmeyes_logo.png": "77ac",
	"./pingan.png": "5028",
	"./publicis.png": "e1da",
	"./qiapeike.png": "1bb0",
	"./rolex.png": "c4bd",
	"./sainofei.png": "634d",
	"./sainuofei.png": "96d7",
	"./sanofi.png": "ae6d",
	"./santen.png": "6c04",
	"./sanyizhongong.png": "0271",
	"./servier.png": "ceb4",
	"./shanghaibank.png": "dd46",
	"./shanghaixuhui.png": "5b97",
	"./shangqi.png": "40d4",
	"./shimao.png": "7a30",
	"./shimfo_img.png": "c268",
	"./shimfo_img_logo.png": "3a17",
	"./shuhe.png": "63ab",
	"./sony.png": "4623",
	"./suning.png": "d6d5",
	"./sunshine.png": "e1d8",
	"./tongcheng.png": "909f",
	"./tongcheng_icon.png": "3435",
	"./tongcheng_icon_active.png": "f48d",
	"./tongfangrenshou.png": "f249",
	"./vip.png": "14fb",
	"./wanke.png": "1af5",
	"./wpp.png": "8e54",
	"./xiaozhuzi.png": "4ba8",
	"./xingye.png": "1b5e",
	"./xinhuashe.png": "02cc",
	"./xinsheng.png": "9430",
	"./yidong.png": "b1d5",
	"./yinlian.png": "6306b",
	"./yiou.png": "6e91",
	"./yum.png": "3e28",
	"./yunhan.png": "da41",
	"./zhaoshang.png": "2011",
	"./zhongguanghe.png": "f9e3",
	"./zhongguohaiyou.png": "0986",
	"./zhongguoyinhang.png": "0e08",
	"./zhongsheng.png": "60cd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a4ad";